export enum LookupsManagementEnum {
    MODULE_ACCESS = 'View',
    VIEW_LOOKUPS = 'View_Lookups',
    EDIT_LOOKUPS = 'Edit_Lookups',
    SAVE_LOOKUPS = 'Save_Lookups',
}
